import React from 'react'
import { formatCurrenctyWithoutSignal, formatDate, getTagInfo } from 'utils'
import { useToaster } from 'hooks'
import { FIREBASE_EVENTS, GET_PAYMENT_URL_ERROR_MESSAGE } from 'app-constants'
import { InvoiceTag } from '../../../../../invoice-tag'
import { PaymentButton } from '../../../../../payment-button'
import './style.scss'

export function InvoiceCard({ slip = {} }) {
  const { isPaymentRecurring, tags, id, value, dueDate } = slip
  const { showErrorToast } = useToaster()

  function handleLinkErrorMessage(error) {
    const errorMessage = error || GET_PAYMENT_URL_ERROR_MESSAGE

    showErrorToast(errorMessage)
  }

  function renderTag() {
    const tagInfo = getTagInfo(false, isPaymentRecurring, tags)

    return <InvoiceTag tagInfo={tagInfo} />
  }

  function renderPaymentButton() {
    return (
      <>
        <PaymentButton
          showErrorMessage={handleLinkErrorMessage}
          invoiceId={id}
          className='invoice-drawer-payment-button'
          event={FIREBASE_EVENTS.CLICK_ON_PAYMENT_GIGA_HELP}
        />
        <span className='text-next-step'>Selecione a forma de pagamento no próximo passo</span>
      </>
    )
  }

  function renderRecurringPayment() {
    return (
      <div className='container-invoice-recurring-payment'>
        <span className='title'>Seu pagamento recorrente está ativo</span>
        <span className='subtitle'>
          Sua fatura será debitada automaticamente na data de vencimento do meio de pagamento
          escolhido.{' '}
        </span>
      </div>
    )
  }

  function renderPaymentInfo() {
    if (isPaymentRecurring) return renderRecurringPayment()

    return renderPaymentButton()
  }

  return (
    <div className='container-invoice'>
      <span className='pay-text'>Valor a pagar</span>
      <div className='container-price'>
        <span className='price-text'>R$</span>
        <span className='value'>{formatCurrenctyWithoutSignal(value)}</span>
      </div>
      <div className='container-due-date-status'>
        <div className='container-due-date'>
          <span className='text'>Vencimento:</span>
          <span className='due-date'>{formatDate(dueDate)}</span>
        </div>
        {renderTag()}
      </div>
      {renderPaymentInfo()}
    </div>
  )
}
